import { Instance, types } from "mobx-state-tree";
import { TopicDTO } from "@closerplatform/spinner-openapi";
import { servicesGetters } from "../utils";
import { ITopic, Topic } from "./topic";
import { flow } from "mobx";
import { logger } from "@fidget/common/utils";
import { sortCaseInsensitiveAscPredicate } from "@fidget/common/utils/sort";
import { notEmpty } from "@fidget/common/utils/not-empty";

export const TopicStore = types
  .model("TopicStore", {
    topics: types.map(Topic)
  })
  .views(servicesGetters)
  .views((self) => {
    const views = {
      getTopics(): ITopic[] {
        return [...self.topics.values()];
      },

      getTagGroupTopics(tagGroupId: string): ITopic[] {
        return views.getTopics().filter((t) => t.tagGroupIds.includes(tagGroupId));
      },

      getByNames(names: string[]): ITopic[] {
        return names.map((n) => self.topics.get(n)).filter(notEmpty);
      },

      get isAnyDefined(): boolean {
        return !!self.topics.size;
      }
    };

    return views;
  })
  .actions((self) => {
    const actions = {
      setTopics(topics: TopicDTO[]) {
        self.topics.clear();
        topics
          .sort((a, b) => sortCaseInsensitiveAscPredicate(a.name, b.name))
          .map((t) => Topic.create({ ...t }))
          .forEach((t) => self.topics.put(t));
      },

      loadTopics: flow(function* () {
        try {
          const topics: TopicDTO[] = yield self.spinnerService.getTopics();

          actions.setTopics(topics);
        } catch (e) {
          logger.error({ message: "Couldn't load topics", error: e });
        }
      })
    };

    return actions;
  });

export interface ITopicStore extends Instance<typeof TopicStore> {}
